

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-select-item',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *mwcStringTemplateOutlet="contentTemplateOutlet; context: { $implicit: contentTemplateOutletContext }">
      <div class="mwc-select-selection-item-content" *ngIf="deletable; else labelTemplate">{{label}}
      </div>
      <ng-template #labelTemplate>{{ label }}</ng-template>
    </ng-container>
    <span *ngIf="deletable && !disabled" class="mwc-select-selection-item-remove" (click)="onDelete($event)">
      <span mwc-icon mwcType="close" *ngIf="!removeIcon; else removeIcon"></span>
    </span>
  `,
  host: {
    class: 'mwc-select-selection-item',
    '[attr.title]': 'label',
    '[class.mwc-select-selection-item-disabled]': 'disabled'
  }
})
export class MwcSelectItemComponent {
  @Input() disabled = false;
  @Input() label: string | number | null | undefined = null;
  @Input() deletable = false;
  @Input() removeIcon: TemplateRef<MwcSafeAny> | null = null;
  @Input() contentTemplateOutletContext: MwcSafeAny | null = null;
  @Input() contentTemplateOutlet: string | TemplateRef<MwcSafeAny> | null = null;
  @Output() readonly delete = new EventEmitter<MouseEvent>();

  constructor() {}

  onDelete(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();
    if (!this.disabled) {
      this.delete.next(e);
    }
  }
}
